import axios from '@axios';

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        fetchSurveys(ctx, queryParams) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/surveys', { params: queryParams })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        checkTestimonial(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/survey/${id}/check`)
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        uncheckTestimonial(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/survey/${id}/uncheck`)
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
    }
}